<template>
	<div id="app">
		<el-container>
			<el-header class="div-header">
				<Header />
				<el-divider class="header-divider"></el-divider>
			</el-header>

			<div class="main-div">
				<el-container class="main-div parentDiv">
					<splitpanes class="default-theme defaultStyle custom-splite">
						<pane size="100" class="SideBarLeft">
							<!--SID0011 Body Part-->
							<template>
								<el-container>
									<div class="SID0011__SearchCondition">
										<section>
											<el-breadcrumb separator-class="el-icon-arrow-right">
												<el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
												<el-breadcrumb-item :to="{ path: '' }"
													>検索条件一覧</el-breadcrumb-item
												>
											</el-breadcrumb>
											<el-row class="buttonSearchConditionTop">
												<el-button type="primary" plain @click="add()">追加</el-button>
												<el-button type="danger" plain @click="removeFromTable()"
													>削除</el-button
												>
												<el-button type="info" plain @click="gototoppage()">戻る</el-button>
											</el-row>
										</section>
										<section>
											<el-table
												v-loading="loading"
												border
												ref="multipleTable"
												:data="getTableResult0011"
												style="width: 100%"
											>
												<el-table-column type="selection" width="60"> </el-table-column>
												<el-table-column label="検索条件タイトル" min-width="350">
													<template slot-scope="scope">
														{{ scope.row.title }}
													</template>
												</el-table-column>
												<el-table-column fixed="left" label="編集" width="100">
													<template slot-scope="scope">
														<el-button type="primary" @click="gotoedit(scope.row)"
															>編集</el-button
														>
													</template>
												</el-table-column>
											</el-table>
										</section>
										<section>
											<el-row class="buttonSearchConditionBottom">
												<el-button type="primary" plain @click="add()">追加</el-button>
												<el-button type="danger" plain @click="removeFromTable()"
													>削除</el-button
												>
												<el-button type="info" plain @click="gototoppage()">戻る</el-button>
											</el-row>
										</section>
									</div>
								</el-container>
							</template>
							<!--SID0011 Body Part End-->
						</pane>

						<pane class="SideBarRight">
							<SideBar class="SidePane" />
						</pane>
					</splitpanes>
				</el-container>
			</div>

			<el-container class="footer-div">
				<el-footer class="footer-element">
					<FooterComponent />
				</el-footer>
			</el-container>
		</el-container>
	</div>
</template>

<script>
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import router from "../../router";
import json from "../../components/config.json";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
export default {
	name: "SearchCondition",
	components: {
		Header,
		SideBar,
		FooterComponent,
		Splitpanes,
		Pane
	},
	data() {
		return {
			loading:false,
			multipleSelection: [],
			deletetableload: ""
		};
	},
	methods: {
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},

		//  Gets called when the user clicks on the 削除 button
		removeFromTable() {
			this.$LogButtonEvent("0011","Delete");
			this.$LogMethodIN("0011","removeFromTable");
			if (this.$refs.multipleTable.selection.length > 0) {
				this.$confirm(
					json["0011_delete_confirm_message"],
					json["0011_delete_confirm_message_title"],
					{
						confirmButtonText: "OK",
						cancelButtonText: "キャンセル"
					}
				).then(() => {
					var selectedArray = this.$refs.multipleTable.selection.length;
					var arrayForDelete = {};
					var titleInfo = [];

					for (var i = 0; i < selectedArray; i++) {
						var assignArray = {};
						assignArray.title = this.$refs.multipleTable.selection[i].title;
						titleInfo.push(assignArray);
					}
					arrayForDelete = { 
						user_id: this.getUserId,
						title_info: titleInfo
					};
					this.$store
						.dispatch("communication0011/deleteSelected", arrayForDelete)
						.then(() => {
							var status = this.getDeleteTable;
							if (status == 0) {
								this.$alert(
									this.getmessageDetail,
									json["0011_delete_success_title"],
									{
										confirmButtonText: "OK"
									}
								).then(() => {
									this.loading=true;
									this.$store.dispatch(
										"communication0011/showTable0011",
										this.deletetableload
									).then(()=>
										{
											this.loading=false;
										})
										.catch(() => {
											this.loading = false;
										})
								});
							} else {
									this.$alert(this.getmessageDetail, "確認", {
										confirmButtonText: 'OK'
									});
								}
						});
				});
			} else {
				this.$alert(
					json["0011_checkbox_not_check_message"],
					json["0011_checkbox_not_check_message_title"],
					{
						confirmButtonText: "OK"
					}
				);
			}
			this.$LogMethodOut("0011","removeFromTable");
		},

		add() {
			this.$LogButtonEvent("0011","Addto");
			this.$LogMethodIN("0011","add");
			this.$store.commit("situation0012/setmediaNameForm", []);
			router.push({ name: "0012" });
			this.$LogMethodOut("0011","add");
		},
		/**
		 * Gets called when the user clicks on the 編集 button
		 * parameters are contract_id,user_id,title
		 */
		gotoedit(row) {
			this.$LogButtonEvent("0011","Add");
			this.$LogMethodIN("0011","gotoedit");
			var titleRow = {
				contract_id: this.getContractId, 
				user_id: this.getUserId,
				title: row.title
			};
			var editToken = {
				flag: 1
			};
			this.$store.dispatch("communication0011/titleEdit", titleRow).then(() => {
				router.push({
					name: "0012",
					params: {
						editToken: editToken
					}
				});
			});
			this.$LogMethodOut("0011","gotoedit");
		},
		gototoppage() {
			this.$LogButtonEvent("0011","Return");
			this.$LogMethodIN("0011","gototoppage");
			router.push({ name: "Home" });
			this.$LogMethodOut("0011","gototoppage");
		}
	},
	computed: {
		...mapGetters("situation0011", [ 
			"getTableResult0011",
			"getcheck",
			"getDeleteTable",
			"getmessageDetail"
		]),
		...mapGetters("situation0001", [
			"getUserId",
			"getContractId",
			
		]) 
	},
	//called after all the DOM elements has been mounted
	mounted() {
		var tableDetails0011 = {
			user_id: this.getUserId
		};
		this.deletetableload = tableDetails0011;
		this.loading=true;
		this.$store.dispatch("communication0011/showTable0011", tableDetails0011).then(()=>
										{
											this.loading=false;
										})
										.catch(() => {
											this.loading = false;
										})
	},
	created() {
		//For the screen Title
		document.title = "記事閲覧";
		var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
		if (isMobile) {
			this.$router.push("sp/0011");
		} else {
			this.$router.push("/0011");
		}
	},
	beforeCreate() {
		//Common.Session.CheckSessionExists_IfExpired_GoToLogout();
	}
};
</script>
<style scoped>
@import "0011.css";
</style>
